var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5C6.78125 10.5 6.10937 10.6094 5.48437 10.8281C4.85937 11.0469 4.28125 11.3542 3.75 11.75V13H11.25V11.75C10.7188 11.3542 10.1406 11.0469 9.51562 10.8281C8.89062 10.6094 8.21875 10.5 7.5 10.5ZM3.75 14.25C3.40625 14.25 3.11208 14.1277 2.8675 13.8831C2.62292 13.6385 2.50042 13.3442 2.5 13V3C2.5 2.65625 2.6225 2.36208 2.8675 2.1175C3.1125 1.87292 3.40667 1.75042 3.75 1.75H11.25C11.5938 1.75 11.8881 1.8725 12.1331 2.1175C12.3781 2.3625 12.5004 2.65667 12.5 3V13C12.5 13.3438 12.3777 13.6381 12.1331 13.8831C11.8885 14.1281 11.5942 14.2504 11.25 14.25H3.75ZM7.5 9.25C8.10417 9.25 8.61979 9.03646 9.04688 8.60938C9.47396 8.18229 9.6875 7.66667 9.6875 7.0625C9.6875 6.45833 9.47396 5.94271 9.04688 5.51562C8.61979 5.08854 8.10417 4.875 7.5 4.875C6.89583 4.875 6.38021 5.08854 5.95312 5.51562C5.52604 5.94271 5.3125 6.45833 5.3125 7.0625C5.3125 7.66667 5.52604 8.18229 5.95312 8.60938C6.38021 9.03646 6.89583 9.25 7.5 9.25Z",
    fill: "#A7A5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.536a9a2b45f0b194d07c9d4135fa5ffb.svg";
export { ForwardRef as ReactComponent };